import { render, staticRenderFns } from "./myfoot.vue?vue&type=template&id=6528b87e&scoped=true"
import script from "./myfoot.vue?vue&type=script&lang=js"
export * from "./myfoot.vue?vue&type=script&lang=js"
import style0 from "./myfoot.vue?vue&type=style&index=0&id=6528b87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528b87e",
  null
  
)

export default component.exports